import React from "react";
import { ErpId, ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { type DocumentResource, DocumentTypes } from "@exonn/js-sdk";
import { RecurringRuns } from "src/admin/modules/document/forms/document/tabs/recurring-runs/RecurringRuns.tsx";
import { DocumentLetters } from "src/admin/modules/document/forms/document/tabs/post/DocumentLetters.tsx";

export const module: ModuleOptions<DocumentResource> = {
  resource: ResourceEnum.Document,
  layoutForm: true,
  // Mahnassistent — просмотр и редактирование напоминаний. Создавать документы с нуля
  // там нечего: список отфильтрован на напоминания, а они выпускаются только
  // «на основе» рехнунга.
  disableCreate: ({ clientConfig }) =>
    [ErpId.Kaufbei].includes(clientConfig.erpId),
  bigIcon: <span className={"icon-20-documents"} />,
  smallIcon: <span className={"icon-15-documents"} />,
  list: {
    filter: ({ clientConfig, user }) => {
      if (
        [ErpId.Kaufbei, ErpId.Stage].includes(clientConfig.erpId) &&
        user?.user_type !== "developer"
      ) {
        return {
          items: [
            {
              field: "document_type",
              operator: "exact",
              value: [DocumentTypes.PaymentReminder, DocumentTypes.Reminder],
            },
          ],
        };
      }
    },
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.document_number,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    texts: {
      title: (t) => t("formTabs.texts.title"),
    },
    addresses: {
      title: (t) => t("formTabs.addresses.title"),
    },
    post: {
      title: (t) => t("formTabs.post.title"),
      routeObject: {
        Component: DocumentLetters,
      },
      // До сохранения писем у документа быть не может.
      isHidden: ({ data }) => !data?.id,
    },
    recurringSchedules: {
      title: (t) => t("formTabs.recurringSchedules.title"),
      isHidden: ({ data }) => {
        return data?.document_type !== DocumentTypes.Invoice;
      },
    },
    recurringRuns: {
      title: (t) => t("formTabs.recurringRuns.title"),
      routeObject: {
        Component: RecurringRuns,
      },
      isHidden: ({ data }) => {
        return data?.document_type !== DocumentTypes.Invoice;
      },
    },
  },
};
